// 配置全局接口域名

// const domain = 'http://127.0.0.1:8084/'
const domain = 'https://api.xinyujia.com.cn/'
// const domain = 'http://192.168.2.7:8084/';

export default {

  apiUrl: domain

}



// WEBPACK FOOTER //
// ./src/domain.js